import { useEffect, useRef, useState } from "react";

const MathJaxRenderer = ({ children }) => {
  const containerRef = useRef(null);
  const [isRendering, setIsRendering] = useState(true);

  useEffect(() => {
    // Set rendering state to true when content changes
    setIsRendering(true);

    if (window.MathJax && window.MathJax.Hub) {
      // Add a small delay to batch multiple MathJax calls
      const timer = setTimeout(() => {
        try {
          // Add to MathJax queue
          window.MathJax.Hub.Queue([
            "Typeset",
            window.MathJax.Hub,
            containerRef.current,
          ]);

          // Set a callback to know when rendering is done
          window.MathJax.Hub.Queue(() => {
            setIsRendering(false);
          });
        } catch (error) {
          console.error("MathJax error:", error);
          setIsRendering(false);
        }
      }, 50);

      return () => clearTimeout(timer);
    } else {
      setIsRendering(false);
    }
  }, [children]);

  return (
    <div ref={containerRef}>
      {children}
      {isRendering && (
        <div
          style={{
            textAlign: "center",
            padding: "0px",
            fontSize: "0.8rem",
            color: "#666",
          }}></div>
      )}
    </div>
  );
};

export default MathJaxRenderer;
